/*
Example 
const pattern = '/workspace/[id]/story/'
const actualPath = buildPathFromPattern(pattern, { id: '123' })
*/
export function buildPathFromPattern(pattern: string, params: Record<string, string | number>) {
    const path = pattern.replace(/\[([^\]]+)\]/g, (_, key) => {
        const value = params[key]
        if (value === undefined) {
            throw new Error(`Missing param '${key}' for pattern '${pattern}'`)
        }
        return String(value)
    })
    return normalizePath(path)
}

export const normalizePath = (path: string) => path.replace(/\/+$/, '') // remove trailing slashes
